import request from '../helpers'

const state = {
  loading: false,
  saving: false,
  chartData: {
    xAxis: [],
    yAxis: [],
    changeRate: 0
  }
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  },
  CHANGE_SAVING_STATE(state, saving) {
    state.saving = saving
  },
  UPDATE_CHART_DATA(state, data) {
    state.chartData = data
  }
}

const actions = {
  getVotes({ dispatch, commit }, data) {
    return request({ 
      commit: commit, 
      method: 'get', 
      url: `causes/${data.causeId}/votes/paged?page=${data.page}&perPage=${data.perPage}&search=${data.search}`,
      includeData: true,
      successCallback: page => {
        dispatch('causes/updateCause', { id: data.causeId, votes: page.results }, { root: true })
      }
    })
  },
  getChartData({ commit }, data) {
    return request({ 
      commit: commit, 
      method: 'get', 
      url: `causes/${data.causeId}/votes/chart?from=${data.from}&to=${data.to}`,
      successCallback: data => {
        commit('UPDATE_CHART_DATA', data)
        commit('settings/UPDATE_ACTIVE_CAUSE_NO_VOTES', data.numberOfVotes, { root: true })
      }
    })
  },
  saveVote({ commit }, data) {
    commit('CHANGE_SAVING_STATE', true)
    return request({ method: 'post', url: `causes/${data.causeId}/votes`, data: data, successCallback: vote => {
      commit('causes/UPDATE_VOTE', vote, { root: true })
      commit('CHANGE_SAVING_STATE', false)
    }})
  },
  deleteVote({ commit }, data) {
    return request({ commit: commit, method: 'delete', url: `causes/${data.causeId}/votes/${data.id}`, data: data, successCallback: vote => {
      commit('causes/DELETE_VOTE', vote, { root: true })
    }})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}